export var VaultTieringPolicyType;
(function (VaultTieringPolicyType) {
    VaultTieringPolicyType["Unspecified"] = "VAULT_TIERING_POLICY_TYPE_UNSPECIFIED";
    VaultTieringPolicyType["EonIntelligentTiering"] = "VAULT_TIERING_POLICY_TYPE_EON_INTELLIGENT_TIERING";
    VaultTieringPolicyType["DaysBeforeArchive"] = "VAULT_TIERING_POLICY_TYPE_DAYS_BEFORE_ARCHIVE";
})(VaultTieringPolicyType || (VaultTieringPolicyType = {}));
